var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10704",
    "data-name": "Group 10704",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.557,
    height: 54.557,
    viewBox: "0 0 54.557 54.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 27.279,
    cy: 27.279,
    r: 27.279,
    transform: "translate(0 0)",
    fill: "#394f65"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10703",
    "data-name": "Group 10703",
    transform: "translate(10.709 9.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WA_Logo",
    "data-name": "WA Logo",
    d: "M2.455,25.947a17.306,17.306,0,1,1,15,8.664h-.007a17.3,17.3,0,0,1-8.269-2.106L0,34.911Zm7.669,3.738a14.357,14.357,0,0,0,7.321,2h.006A14.38,14.38,0,1,0,5.266,24.951l.342.544L4.155,30.8,9.6,29.374Zm10.151-4.32a24.855,24.855,0,0,1-2.465-.911c-4.338-1.872-7.17-6.238-7.386-6.527a8.409,8.409,0,0,1-1.766-4.472A4.846,4.846,0,0,1,10.171,9.85a1.588,1.588,0,0,1,1.153-.541c.288,0,.576,0,.829.015.031,0,.064,0,.1,0,.252,0,.566,0,.876.741.36.866,1.225,2.993,1.333,3.21a.8.8,0,0,1,.036.757,2.964,2.964,0,0,1-.432.721c-.216.253-.454.564-.649.758-.216.215-.442.449-.189.882a13.023,13.023,0,0,0,2.406,2.994,11.8,11.8,0,0,0,3.477,2.145c.432.217.685.181.937-.108s1.081-1.262,1.369-1.695.576-.361.973-.216,2.522,1.19,2.954,1.406.721.325.829.505a3.615,3.615,0,0,1-.252,2.055A4.455,4.455,0,0,1,23,25.536a7.1,7.1,0,0,1-1.049.083A5.49,5.49,0,0,1,20.275,25.365Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7939f50f0dfe06f0092729e1990ba2d2.svg";
export { ForwardRef as ReactComponent };